'use strict';

/* global $ */

import { breakpoints } from '../settings'

function More(){

	$('.js-more-link').click(function (e) {
		e.preventDefault();
        let item = $('.activ-item');
        let links = $(this).closest(item).find(".js-more-links");
        let content = $(this).closest(item).find(".js-more-content");
        if (links.is(':visible')) {
            $(this).html('Подробнее');
            links.slideUp(500); 
            content.slideUp(1000);

            
        } else if(links.is(':hidden')){
            links.slideDown(500); 
            content.slideDown(750);

            $(this).html('Свернуть');
        }  
    });

    $('.js-hide').click(function (e){
        e.preventDefault();
        e.stopPropagation();
        let item = $(this).parent().find('.js-group');
        if( item.is(':visible') ){
            $(this).html('развернуть');
            item.slideUp(500); 
            if ( window.innerWidth < breakpoints.m) {
                $(this).parent().removeClass('shadow').css('z-index',1);
            }
            
        }else if(item.is(':hidden')){
            item.slideDown(500); 
            $(this).html('свернуть');
            if ( window.innerWidth < breakpoints.m) {
                $(this).parent().addClass('shadow').css('z-index',11);
            }
        }  
    });

    if ( window.innerWidth < breakpoints.m){
        let item = $('.js-group');
        item.hide();
        $('.js-hide').html('развернуть');
    }

    $(document).click(function(){
        if ( window.innerWidth < breakpoints.m && !event.target.closest('.js-group')) {
            $(".js-group").slideUp(500);
            $('.js-hide').html('развернуть').parent().removeClass('shadow').css('z-index',1);
        }
    });
}

function Branch(){
    let branch = $('.js-branch');
    let item = $('.js-branch-item');
    let text = $('.js-branch-text');

    function padd(){
        let windowWidth = window.innerWidth;

        if ( window.innerWidth > breakpoints.m) {
            $('.js-hide').parent().removeClass('shadow').css('z-index',3);
        }

        if (windowWidth > breakpoints.xxs+60) {
            for(let i=0;i<branch.length;i++){
                let itemHeight = branch.eq(i).height();
                let textHeight = text.eq(i).height();
                item.eq(i).css('padding-top',(itemHeight-textHeight-1)/2);
            }
        }else{
            item.css('padding-top',110);
        }
    }

    $(document).ready(function() { 
        
    });
}

function Catalog(){

    var dropdown = document.querySelectorAll('.dropdown');
    var dropdownArray = Array.prototype.slice.call(dropdown,0);

    dropdownArray.forEach(function(el){
        var button = el.querySelector('.icon-arrow') || el.querySelector('.icon-arrow__left'),
            menu = el.querySelector('.dropdown-menu');

        // let arrow;
        // if ( button.parentElement.querySelector('.icon-arrow') ){
        //     arrow = button.parentElement.querySelector('.icon-arrow');
        // } else if ( button.parentElement.querySelector('.icon-arrow__left') ){
        //     arrow = button.parentElement.querySelector('.icon-arrow__left');
        // }
        
        if ($(dropdown).find('.is-active')) {
            $(dropdown).find('.is-active').each(function() {
                $(this).closest(menu).addClass('show');
                $(this).parent().find(button).addClass('open');  
            });
        }        

        button.onclick = function(event) {
            event.preventDefault();
            event.stopPropagation();
            if (menu){
                if (!menu.hasClass('show')) {
                    
                    menu.classList.add('show');
                    menu.classList.remove('hide');
                    this.classList.add('open');
                    this.classList.remove('close');
                    event.preventDefault();
                } else {
                    document.body.classList.add('shadow');
                    menu.classList.remove('show');
                    menu.classList.add('hide');
                    this.classList.remove('open');
                    this.classList.add('close');
                    event.preventDefault();
                }
            }

        };
    })

    Element.prototype.hasClass = function(className) {
        return this.className && new RegExp("(^|\\s)" + className + "(\\s|$)").test(this.className);
    };
}

function Tabs(options) {

  let opt = $.extend({
    menuSelector: '.js-tab-links',
    blockSelector: '.js-tab-items',
    itemSelector: '.js-tab-item',
  }, options);

  let item = opt.itemSelector,
    links = opt.menuSelector,
    block = opt.blockSelector;

    $(document).ready(function() { 
        
        $(links).addClass('active').find('> a:eq(0)').addClass('selected');
        $(block).find('.js-tab-item:eq( 0 )').addClass('selected');

        $('.js-tab-links div').click(function (g) {
            g.preventDefault(); 
            var tab = $(this).closest(links), 
                index = $(this).closest('div').index();
            
            tab.find('div').removeClass('selected');
            $(this).closest('div').addClass('selected');
            
            $(block).find(item).not('.js-tab-item:eq(' + index + ')').removeClass('selected').hide(200);

            $(block).find('.js-tab-item:eq(' + index + ')').addClass('selected').show(200);
            
        });
        
    });

    item = '.js-tabs__menu-item';
    block = '.js-tabs__item';
    $(document).ready(function () {
        if (!$(item).hasClass('is-active')) {
            $(item).eq(0).addClass('is-active');
            $(block).eq(0).addClass('is-active');
        }
        $(item).click(function (e) {
            e.preventDefault();
            var index = $(this).attr('href');
            $(item).removeClass('is-active');
            $(block).removeClass('is-active');
            $(this).addClass('is-active');
            $(block).filter(index).addClass('is-active');
        });
    });

}

function Activities (options) {
    let opt = $.extend({
        contentSelector: '.js-activity__content',
        titleSelector: '.js-activity__title',
        blockSelector: '.js-activity',
        itemSelector: '.js-activity__item',
    }, options);

    function InitAct (block) {
        let items = $(block).find(opt.itemSelector);

        $(items).each(function() {
            ActItem(this); 
        });
    }

    function ActItem (item) {
        let title = $(item).find(opt.titleSelector);
        let content = $(item).find(opt.contentSelector);

        $(title).on('click', function() {

            if (this.classList.contains('active')) {
                CloseAll();
                this.classList.remove('active');
            } else {
                CloseAll();
                this.classList.add('active');
                $(content).slideToggle();
            }
        });
    }

    function CloseAll() {
        let titles = $(opt.blockSelector).find(opt.titleSelector);
        let contents = $(opt.blockSelector).find(opt.contentSelector);
        $(titles).removeClass('active');
        $(contents).slideUp();
    }

    $(opt.blockSelector).each(function() {
        InitAct(this); 
    });

}

export {
    More,
    Branch,
    Catalog,
    Tabs,
    Activities
};